import { Source } from '../../../../common/constants';
import { addQueryParams } from '../../../../common/routing/addQueryParams';
import { PracticePractitioner } from '../../../../profile/types';

export const createBookURL = (
  practiceId: string,
  staff: PracticePractitioner,
  source?: Source | string,
  specialty?: string,
): string | null => {
  let baseURL = `/public/practice/appointments.php`;

  baseURL = addQueryParams(baseURL, { id: practiceId, target: '_parent' });

  // the createBookURL shouldn't be used if there is no `docId` anyway
  //    because it would be meaningless
  if (staff.practitionerProfileId) {
    // eslint-disable-next-line camelcase
    baseURL = addQueryParams(baseURL, { doc_id: staff.practitionerProfileId });
  } else {
    return null;
  }

  // if a specialty is passed add it to the url
  if (specialty) {
    baseURL = addQueryParams(baseURL, { specialty });
  }

  // add source if provided
  if (source) {
    baseURL = addQueryParams(baseURL, { source });
  }

  return baseURL;
};
